import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogContent } from "@material-ui/core";
import SignaturePad from "react-signature-canvas";
import { uploadFile } from "../s3UploadService";
import { isMobile } from "react-device-detect";
import { NotificationManager } from "react-notifications";
import { ReactComponent as CancelIcon } from "../../assets/cancel.svg"

function SignatureModal(props) {
  const [direction, setDirection] = useState("");
  const sigPad = React.useRef();
  const [modalTabs, setModaltabs] = useState(2);
  const [objectUrl, setObjectUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [uplodFile, setUploadFile] = useState();

  let urlString = window.location.href.split("/");
  let encodeId = urlString[urlString.length - 1];

  useEffect(() => {
    setTimeout(() => {
      const body = document.getElementById("body")
      const direc = getComputedStyle(body).direction;
      setDirection(direc)
    }, 100)
  }, [])

  useEffect(() => {
    setObjectUrl("");
  }, [props.open]);

  const uploadSign = (e) => {
    const objectURL = URL.createObjectURL(e.target.files[0]);
    setObjectUrl(objectURL);
    setUploadFile(e.target.files[0]);
  };

  const save = () => {
    if (modalTabs === 2) {
      if (
        sigPad.current.getTrimmedCanvas().width !== 1 ||
        sigPad.current.getTrimmedCanvas().height !== 1
      ) {
        setLoading(true);

        dataUrlToFile(
          sigPad.current.getTrimmedCanvas().toDataURL("image/png"),
          "img",
          "convert"
        );
      } else {
        NotificationManager.warning(
          "חובה למלא את החתימה על מנת לשמור"
        );
      }
    }

    if (modalTabs === 3) {
      setLoading(true);
      props.setImg(objectUrl);
      props.setImg2(objectUrl);
      dataUrlToFile(uplodFile, "img", "notConvert");
    }
  };

  async function dataUrlToFile(dataUrl, fileName, convert) {
    if (convert === "convert") {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      let pngFile = new File([blob], fileName, { type: "image/png" });
      let divREf = props.divReference;

      uploadFile(pngFile, encodeId).then((res) => {
        props.setImg({ divRef: divREf, img: res.data.result.signature[0].url });
        props.setImg2({ divRef: divREf, img: res.data.result.signature[0].url2 });
        props.setopen(false);
        setLoading(false);
      });
    } else {
      let pngFile = dataUrl;
      let divREf = props.divReference;
      uploadFile(pngFile, encodeId)
        .then((res) => {
          props.setImg({ divRef: divREf, img: res.data.result.signature[0].url });
          props.setImg2({ divRef: divREf, img: res.data.result.signature[0].url2 });
          props.setopen(false);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }

  // const clear = () => {
  //   sigPad.current.clear();
  // };


  return (
    <Dialog open={props.open} onClose={() => props.handleClose()}>
      {/* <DialogTitle id="alert-dialog-title">{props.msg}</DialogTitle> */}
      <DialogContent>
        <div className="signModalWith">
          <div className="d-flex jc-end py-10">
            {/* <img src={signPen} width="180" alt="sign pen" /> */}
            <CancelIcon className="cursor-pointer" onClick={() => props.handleClose()} />

          </div>
          <div className="d-flex jc-center bg-light-gray pb-10 br-20 px-15 gap-3">
            <div
              onClick={() => setModaltabs(2)}
              className={`${modalTabs === 2 && "bg-orange color-white"
                } py-10 px-20 br-none cursor-pointer text-center signature ${isMobile ? "fs-16" : "fs-20"
                } `}>
              {/* {direction === "rtl" ? "מלאת חתימה" : "Draw Signature"} */}
              מלאו חתימה
            </div>
            {props.disableFileUpload ? (
              <div
                onClick={() => setModaltabs(3)}
                className={`${modalTabs === 3 && " bg-orange color-white"
                  } py-10 px-20 br-none cursor-pointer text-center signature ${isMobile ? "fs-16" : "fs-20"
                  }`}>
                {/* {direction === "rtl" ? "מלאו חתימה" : "Upload Signature"} */}
                העלאת חתימה
              </div>
            ) : null}
          </div>
          {modalTabs === 1 && (
            <div className="canvas-div">
              <div
                className="d-flex jc-between flex-wrap"
                style={{ width: "100%" }}>
                <div className="p-10 flex-grow-1">
                  <div className="saved-sign">חתימה</div>
                </div>
                <div className="p-10 flex-grow-1">
                  <div className="saved-sign">חתימה</div>
                </div>
                <div className="p-10 flex-grow-1">
                  <div className="saved-sign">חתימה</div>
                </div>
              </div>
            </div>
          )}

          {modalTabs === 2 && (
            <div className="my-10">
              <div className="canvas-div">
                <SignaturePad
                  ref={sigPad}
                  penColor="green"
                  canvasProps={{
                    width: 730,
                    height: 320,
                    className: "sigCanvas",
                  }}
                />
                <hr className="mx-10" />
              </div>
            </div>
          )}

          {modalTabs === 3 && (
            <div className="my-10">
              <div className="image-upload">
                <label for="file-input">
                  <div className="sign-upload-input cursor-pointer">
                    <div
                      style={{ height: "100%", width: "100%" }}
                      className="d-flex jc-center ai-center">
                      {objectUrl ? (
                        <img alt="upload" style={{ height: "50%" }} src={objectUrl} />
                      ) : (
                        <div
                          className={`fw-500 ${isMobile ? "fs-32" : "fs-22"}`}>
                          {/* {direction === "rtl" ? "בחר קובץ" : "Select File"} */}
                          בחירת קובץ
                        </div>
                      )}
                    </div>
                  </div>
                </label>
                <input onChange={uploadSign} id="file-input" type="file" />
              </div>
            </div>
          )}
          <div className="d-flex jc-center py-10">
            <button
              className={`bg-white hover-orange br-black color-black cursor-pointer br-none ${isMobile ? "fs-16" : "fs-20"
                } py-5 px-10 color-white`}
              onClick={save}>
              {loading ? "טוען...." : "שמירה"}
            </button>
            {/* 
            {modalTabs === 2 && (
              <button
                className={`bg-orange cursor-pointer br-none ${
                  isMobile ? "fs-16" : "fs-20"
                } py-5 px-10 color-white mx-20`}
                onClick={clear}>
                clear
              </button>
            )} */}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SignatureModal;
